module.exports = __webpack_public_path__ + "assets/retina_ATrByCentroidDetailed.a25dbcc4ce5503c01d24e9d3db1c3b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ATrByCentroidDetailed.png
// module id = 609
// module chunks = 0